import { AddressForm } from "@/components/address/AddressForm";
import { Form } from "antd";
import { useTranslation } from "react-i18next";
import { Country } from "../../../../../common/enums";
import { ClientType } from "../../../enums";
import { CreateUpdateClient } from "../../../types";
import { resolveClientAddressLabel } from "../../../utils";

type Props = {
  hasCorrespondenceAddress?: boolean;
};

export const ClientAddressesFormPart = ({ hasCorrespondenceAddress }: Props) => {
  const { t } = useTranslation();

  const form = Form.useFormInstance();
  const clientType = Form.useWatch("type", form) as CreateUpdateClient["type"] | undefined;
  const nationality = Form.useWatch("nationality", form) as Country | undefined;

  return (
    <>
      <AddressForm
        formItemsNamePath={["address"]}
        label={resolveClientAddressLabel(clientType ?? ClientType.NATURAL, nationality)}
        required
      />

      <AddressForm
        formItemsNamePath={["correspondenceAddress"]}
        label={t("client.attrs.correspondenceAddress")}
        hasInitialAddress={hasCorrespondenceAddress}
      />
    </>
  );
};
